import { makeNoteAPIs } from '../../modules/noteAPIFactory'
import { getSupplierNoteListData } from './mockData'
import type { ISupplierNote } from '~/types/note/models'

export const {
  getNotes: getSupplierNotes,
  postNote: postSupplierNote,
  patchNote: patchSupplierNote,
  deleteNote: deleteSupplierNote,
  handlers,
} = makeNoteAPIs<ISupplierNote>({
  apiPathEntityNamePrefix: 'supplier',
  getNoteListDataFn: getSupplierNoteListData,
})
